module.exports = __webpack_public_path__ + "static/media/header2.3f05f1ba.png";